export const hideVolumeControl = (): void => {
  const volume = document.getElementById("volume");
  if (volume) volume.style.display = "none";
  const volumeIcon = document.getElementsByClassName(
    "Waveform-module_icon__yBv0P"
  );
  for (let i = 0; i < volumeIcon.length; i++) {
    const volumeIcons = volumeIcon[i] as HTMLElement;
    if (volumeIcons.lastElementChild?.localName !== "svg") {
      volumeIcons.style.display = "none";
    }
  }
};
